<!-- Update Car Modal -->
<div class="modal fade" id="kt_modal_update_car" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header" id="kt_modal_update_car_header">
        <h2 class="fw-bold">Update Car</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" aria-label="Close">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <div class="modal-body py-10 px-lg-17">
        <form [formGroup]="carForm" (ngSubmit)="onSubmit()">
          <div class="scroll-y me-n7 pe-7" style="max-height: 500px;">

            <!-- Disabled Fields Section -->
            <div class="mb-7">
              <h5 class="text-gray-700 fw-semibold mb-5">Vehicle Information</h5>

              <!-- Inventory Number (Disabled) -->
              <div class="mb-5">
                <label class="form-label fw-semibold text-gray-600 fs-7">Inventory Number</label>
                <input
                  type="text"
                  class="form-control form-control-solid"
                  formControlName="inventory_no"
                  readonly>
              </div>

              <!-- Name (Disabled) -->
              <div class="mb-5">
                <label class="form-label fw-semibold text-gray-600 fs-7">Name</label>
                <input
                  type="text"
                  class="form-control form-control-solid"
                  formControlName="name"
                  readonly>
              </div>

              <!-- Company Name (Disabled) -->
              <div class="mb-5">
                <label class="form-label fw-semibold text-gray-600 fs-7">Company Name</label>
                <input
                  type="text"
                  class="form-control form-control-solid"
                  formControlName="company_name"
                  readonly>
              </div>

              <!-- Year (Disabled) -->
              <div class="mb-5">
                <label class="form-label fw-semibold text-gray-600 fs-7">Year</label>
                <input
                  type="text"
                  class="form-control form-control-solid"
                  formControlName="year"
                  readonly>
              </div>
            </div>

            <!-- Editable Fields Section -->
            <div class="mb-7">
              <h5 class="text-gray-700 fw-semibold mb-5">Dimensions</h5>

              <!-- Car Length -->
              <div class="mb-5">
                <label class="required form-label fw-semibold text-gray-600 fs-7">Car Length (cm)</label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="car_length"
                  placeholder="Enter car length"
                  [class.is-invalid]="car_length?.invalid && car_length?.touched">
                <div *ngIf="car_length?.invalid && car_length?.touched" class="invalid-feedback">
                  <div *ngIf="car_length?.errors?.['required']">Car length is required</div>
                </div>
              </div>

              <!-- Car Width -->
              <div class="mb-5">
                <label class="required form-label fw-semibold text-gray-600 fs-7">Car Width (cm)</label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="car_width"
                  placeholder="Enter car width"
                  [class.is-invalid]="car_width?.invalid && car_width?.touched">
                <div *ngIf="car_width?.invalid && car_width?.touched" class="invalid-feedback">
                  <div *ngIf="car_width?.errors?.['required']">Car width is required</div>
                </div>
              </div>

              <!-- Car Height -->
              <div class="mb-5">
                <label class="required form-label fw-semibold text-gray-600 fs-7">Car Height (cm)</label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="car_height"
                  placeholder="Enter car height"
                  [class.is-invalid]="car_height?.invalid && car_height?.touched">
                <div *ngIf="car_height?.invalid && car_height?.touched" class="invalid-feedback">
                  <div *ngIf="car_height?.errors?.['required']">Car height is required</div>
                </div>
              </div>
            </div>

          </div>

          <!-- Modal Footer -->
          <div class="modal-footer flex-center pt-10">
            <button
              type="button"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
              [disabled]="isLoading">
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="isLoading">
              <span *ngIf="!isLoading">Update</span>
              <span *ngIf="isLoading">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Updating...
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
